import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import { useSmartTranslation } from '../../../../../../generic/hooks/useSmartTranslation'
import { systemValueLabel } from '../../../../../../generic/systemValues/systemValueLabel'
import { useMemo } from 'react'

/**
 * Component to display the status of a job as a colored chip.
 *
 * @component
 * @example
 * <JobStatusChip status="Completed" statusType="FINISHED" />
 *
 * @param {Object} props - Component props
 * @param {string} props.status - The localized status label to display
 * @param {string} props.statusType - The type of status (e.g., 'FINISHED', 'INTERRUPTED') to determine color
 * @returns {JSX.Element} The rendered Chip component
 */
const JobStatusChip = ({ status, statusType }) => {
  const { t_ } = useSmartTranslation()

  const color = useMemo(() => {
    switch (statusType) {
      case 'FINISHED':
        return 'primary'
      case 'INTERRUPTED':
        return 'warning'
      case 'NOT AVAILABLE':
        return 'default' // Changed undefined to 'default' for clarity, though MUI accepts undefined
      default:
        return 'info'
    }
  }, [statusType])

  return (
    <Chip
      label={systemValueLabel(t_, 'DeviceFabricationOrderStatusTypeEnum', status || '')}
      color={color}
      size='small' // Added size small for better fit in tables/lists
      variant='filled'
    />
  )
}

JobStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  statusType: PropTypes.string
}

export default JobStatusChip
